/* @ngInject */
function TagsController ($scope, $state, $translate, UdsModalService, TagsService) {
  const getCreateTagController = () => import('../../dialogs/create-tag/create-tag.controller')

  $scope.$parent.selectedMenuId = $state.current.data.selectedMenuId
  $scope.tagsTotal = 0
  $scope.loading = false
  $scope.top = 10
  $scope.skip = 0
  $scope.isAsc = true
  $scope.order = ''
  $scope.sort = ''
  $scope.iconCreatedAt = 'chevron-down'
  $scope.iconCreatedBy = 'chevron-down'
  $scope.iconName = 'chevron-down'
  $scope.iconArts = 'chevron-down'
  $scope.tags = []
  $scope.pageTitle = ''

  const api = {
    _getTags,
    _setIcon
  }

  this.getApi = () => api

  function activate () {
    $scope.loading = true
    $scope.isAsc = false
    api._setIcon('chevron-down')
    api._getTags({ skip: $scope.skip, top: $scope.top })
  }

  activate()

  $translate.onReady(() => {
    $scope.pageTitle = $translate.instant('tags')
  })

  function _getTags (queryParams) {
    TagsService.getTags(queryParams).then((response) => {
      $scope.tags = response.rows
      $scope.tagsTotal = response.count
      $scope.loading = false
    })
  }

  function _setIcon (icon) {
    if ($scope.sort === 'createdAt') {
      $scope.iconCreatedAt = icon
    } else if ($scope.sort === 'createdBy') {
      $scope.iconCreatedBy = icon
    } else if ($scope.sort === 'name') {
      $scope.iconName = icon
    } else if ($scope.sort === 'arts') {
      $scope.iconArts = icon
    }
  }

  $scope.toggle = function (flag) {
    $scope.sort = flag
    $scope.isAsc = !$scope.isAsc

    if (!$scope.isAsc) {
      $scope.order = 'ASC'
      api._setIcon('chevron-down')
      api._getTags({
        sort: $scope.sort,
        order: $scope.order,
        skip: $scope.skip,
        top: $scope.top
      })
    } else {
      $scope.order = 'DESC'
      api._setIcon('chevron-up')
      api._getTags({
        sort: $scope.sort,
        order: $scope.order,
        skip: $scope.skip,
        top: $scope.top
      })
    }
  }

  $scope.getPaginationPage = function (ev) {
    $scope.skip = (ev.detail.currentPage - 1) * $scope.top
    api._getTags({
      name: $scope.searchedName,
      order: $scope.order,
      skip: $scope.skip,
      top: $scope.top,
      sort: $scope.sort
    })
  }

  $scope.tagsSearch = (term) => {
    $scope.searchedName = term
    if ($scope.searchedName) {
      $scope.skip = 0
    } else if ($scope.searchedName === '') {
      api._getTags({
        skip: $scope.skip,
        top: $scope.top
      })
    }
    api._getTags({
      name: $scope.searchedName,
      sort: $scope.sort,
      order: $scope.order,
      skip: $scope.skip,
      top: $scope.top
    })
  }

  $scope.openCreateTagModal = function (data) {
    const createTagData = {
      flag: data.flag,
      tagId: data.tagId,
      name: data.name,
      location: 'arts'
    }
    getCreateTagController().then(({ CreateTagController }) => {
      const createTag = UdsModalService.createModal({
        controller: CreateTagController,
        modalName: 'createTag',
        data: createTagData,
        onClose: (returnData) => {
          if (returnData?.success) {
            api._getTags({
              name: $scope.searchedName,
              sort: $scope.sort,
              order: $scope.order,
              skip: $scope.skip,
              top: $scope.top
            })
          }
        },
        onOpen: () => {}
      })

      createTag.open()
    })
  }

  $scope.headerNavigation = {
    buttons: [{
      type: 'button',
      btnType: 'primary',
      label: $translate.instant('newTag'),
      icon: 'plus',
      onClick: $scope.openCreateTagModal.bind(null, { flag: 'create' })
    }]
  }

  $scope.headerToolbar = {
    search: {
      onSearch: $scope.tagsSearch
    }
  }
}

export { TagsController }
